// extracted by mini-css-extract-plugin
module.exports = {"content":"dateandtime_content__TFz35","center":"dateandtime_center__2egAC"};